<template>
  <a class="support-block" :href="`tel:${supportPhone}`" target="_blank">
    <span class="support-block__icon">
      <svg
        width="16"
        height="15"
        viewBox="0 0 16 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.65679 12.2816C3.26286 12.2817 2.87384 12.1942 2.51792 12.0253C2.16199 11.8565 1.84807 11.6106 1.5989 11.3055C1.34972 11.0004 1.17153 10.6437 1.07723 10.2612C0.98293 9.87875 0.974881 9.48009 1.05367 9.09412C1.19046 8.48354 1.53357 7.9388 2.02517 7.55172C2.51677 7.16463 3.1268 6.95887 3.75242 6.96912H4.58648V12.2816H3.65679Z"
          fill="#47475D"
          stroke="#47475D"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.8911 12.2816C12.285 12.2817 12.6741 12.1942 13.03 12.0253C13.3859 11.8565 13.6998 11.6106 13.949 11.3055C14.1982 11.0004 14.3764 10.6437 14.4707 10.2612C14.565 9.87875 14.573 9.48009 14.4942 9.09412C14.3574 8.48354 14.0143 7.9388 13.5227 7.55172C13.0311 7.16463 12.4211 6.95887 11.7955 6.96912H10.9614V12.2816H11.8911Z"
          fill="#47475D"
          stroke="#47475D"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.99244 6.96853V6.34165C2.9733 5.24697 3.32589 4.17814 3.99264 3.30973C4.65939 2.44131 5.60089 1.82463 6.66338 1.5604C7.36752 1.39228 8.10064 1.38626 8.80745 1.54277C9.51425 1.69929 10.1763 2.01426 10.7436 2.46393C11.311 2.91361 11.7688 3.48624 12.0825 4.13864C12.3963 4.79104 12.5578 5.50617 12.5549 6.23009V6.96853"
          stroke="#47475D"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.58643 12.2812C4.58643 12.7039 4.75434 13.1093 5.05322 13.4082C5.35211 13.7071 5.75749 13.875 6.18018 13.875"
          stroke="#47475D"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.0239 6.96875H10.9614V12.2812H12.0239V6.96875Z"
          fill="#47475D"
        />
      </svg>
    </span>
    <span class="support-block__text">
      {{ supportPhone }}
    </span>
  </a>
</template>

<script>
import { SUPPORT_PHONE } from '@js-app/const/config'
export default {
  name: 'HeaderSupportBlock',
  data() {
    return {
      supportPhone: SUPPORT_PHONE,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@css-app/variables';
.support-block {
  display: flex;
  align-items: center;
  text-decoration: none;
  &__icon {
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;

    svg {
      max-width: 100%;
      max-height: 100%;
    }
  }

  &__text {
    font-size: pxToRem(16);
    line-height: pxToRem(20);
    color: $text1;
    font-weight: 500;
  }
}
</style>
